import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import LightGrayBgWrapper from "../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import ColoredText from "../../../../components/common/AdminCommonComponents/ColoredText/ColoredText"
import DynamicButton from "../../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDropdown from "../../../../components/common/AdminCommonComponents/DynamicDropdown/DynamicDropdown"
import DynamicDatatable from "../../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"

const Currency = () => {

  const currencyOptions = [
    { label: 'United States Dollar' },
    { label: 'Euro' },
    { label: 'United Arab Emirates Dirham' },
    { label: 'British Pound Sterling' },
  ]

  const currienciesTableData = [
    { currencyName: 'United States Dollar', currencySymbol: '$', currencyCode: 'USD', status: 'Active' },
    { currencyName: 'Euro', currencySymbol: '€', currencyCode: 'EUR', status: 'Active' },
    { currencyName: 'United Arab Emirates Dirham', currencySymbol: 'DH', currencyCode: 'AED', status: 'Active' },
    { currencyName: 'Pakistani Rupee', currencySymbol: 'Rs', currencyCode: 'PKR', status: 'Active' },
    { currencyName: 'British Pound Sterling', currencySymbol: '£', currencyCode: 'GBP', status: 'Active' },
  ]

  const currencyColumns = [
    {
      name: 'Currency Name',
      selector: row => row.currencyName,
    },
    {
      name: 'Symbol',
      selector: row => row.currencySymbol,
      center: 'true'
    },
    {
      name: 'Currency Code',
      selector: row => row.currencyCode,
      center: 'true'
    },
    {
      name: 'Status',
      selector: row => row.status,
      cell: row => (
        <ColoredText color={row.status === 'Active' ? "#41B8E4" : "red"}>{row.status}</ColoredText>
      ),
      center: 'true'
    },
    {
      name: 'Action',
      cell: () => <button style={{ all: "unset" }}>Remove</button>
    }
  ];  

  return (
    <LightGrayBgWrapper>
      <Row className="row-cols-1 row-cols-lg-2">
        <Col className="d-grid">
          <div className="p-3 shadow bg-white">
            <div className="d-flex align-items-center justify-content-between">
              <ColoredText color="#EC7426" cn="fs-5 fw-medium">
                Add new Currency
              </ColoredText>
              <DynamicButton theme="blue">Add</DynamicButton>
            </div>
            <Form className="mt-3" onSubmit={(e) => e.preventDefault()}>
              <FormGroup>
                <Label className="fw-medium" for="currencyName">
                  Enter Currency Name
                </Label>
                <Input id="currencyName" name="currencyName" placeholder="" type="text" />
              </FormGroup>
              <FormGroup>
                <Label className="fw-medium" for="currencySymbol">
                  Enter Currency Symbol
                </Label>
                <Input id="currencySymbol" name="currencySymbol" placeholder="" type="text" />
              </FormGroup>
              <FormGroup>
                <Label className="fw-medium" for="currencyCode">
                  Enter Currency Code
                </Label>
                <Input id="currencyCode" name="currencyCode" placeholder="" type="text" />
              </FormGroup>
            </Form>
          </div>
        </Col>
        <Col className="d-grid">
          <div className="p-3 shadow bg-white">
            <ColoredText color="#EC7426" cn="fs-5 fw-medium mb-3">
              System Default Currency
            </ColoredText>


            <DynamicDropdown options={currencyOptions} />
            <div className="mt-4 text-center">
              <DynamicButton theme="blue">Save</DynamicButton>
            </div>
          </div>
        </Col>
      </Row>

      <div className="mt-3">
        <div className="fw-semibold fs-5 bg-white p-3 shadow rounded-top">Currencies</div>

        <DynamicDatatable data={currienciesTableData} columns={currencyColumns} type='yellow' />
      </div>
    </LightGrayBgWrapper>
  )
}

export default Currency
